import { Box, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import eyebox from "../../Utils/Images/eyebox.png";
import deletebox from "../../Utils/Images/deletebox.png";
import editbox from "../../Utils/Images/editbox.png";
import CustomButton from "../Button/CustomButton";
import { Link } from "react-router-dom";
import { handleDeleteProduct } from "../../APIs/Function/Product/DeleteProduct";
import DeleteModal from "../Modal/DeleteModal";
import { GetProduct } from "../../APIs/Function/Product/GetProduct";
import Loader from "../Loader/Loader";

const ProductTable = ({ productData, setProductData, setLoading, loading }) => {
  const [open, setOpen] = useState(false);
  const [modalID, setModalID] = useState("");
  const [loadinga, setLoadinga] = useState(false);

  const handleClose = () => {
    setOpen(!open);
  };

  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };

  const handleDelete = async (modalID) => {
    try {
      setOpen(false);
      await handleDeleteProduct(modalID);
      alert("Product Delete Successfully");
      setLoadinga(true);
      let res = await GetProduct();
      setLoadinga(false);
      setProductData(res.r);
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  useEffect(() => {}, [productData]);

  return (
    <>
      {loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          <Box>
            {/* heading */}
            <Box
              sx={{
                boxShadow: "none",
                outline: "none",
                mb: "10px",
                border: "none",
                mt: "10px",
                boxSizing: "border-box",
              }}
            >
              <Grid container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      #
                    </Typography>
                  </Paper>
                </Grid>
                {/* Second Column */}
                <Grid item xs={1.5} md={1.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      Photo
                    </Typography>
                  </Paper>
                </Grid>
                {/* Third Column */}
                <Grid item xs={1.5} md={1.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      Product ID
                    </Typography>
                  </Paper>
                </Grid>
                {/* Fourth Column */}
                <Grid item xs={2} md={2}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      Product Name
                    </Typography>
                  </Paper>
                </Grid>
                {/* fifth Column */}
                <Grid item xs={1.5} md={1.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      Actual Price
                    </Typography>
                  </Paper>
                </Grid>
                {/* Sixth Column */}
                <Grid item xs={1.5} md={1.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      Discounted Price
                    </Typography>
                  </Paper>
                </Grid>
                {/* Seventh Column */}
                <Grid item xs={1.5} md={1.5}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                      // bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      Product Reviews
                    </Typography>
                  </Paper>
                </Grid>
                {/* Eigth */}
                <Grid item xs={2} md={2}>
                  <Paper
                    sx={{
                      borderRadius: "0px",
                     border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                      bgcolor: "#E6E6E6",
                      // bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        opacity: "85%",
                        color: "#252525",
                      }}
                    >
                      Action
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                border: "1px solid #DDDDDD",
                height: "100%",
                overflow: "auto",
                "&:hover": {
                  "::-webkit-scrollbar": {
                    width: "5px",
                    borderRadius: "10px",
                  },
                  "::-webkit-scrollbar-thumb": {
                    bgcolor: "gray",
                    borderRadius: "10px",
                  },
                },
                mt: "10px",
                borderTop: "0.5px solid #DDDDDD",
                maxHeight: "75vh",
              }}
            >
              <Box>
                <Grid container>
                  {/* first column */}
                  <Grid item xs={0.5} md={0.5}>
                    {productData?.map((item, i) => (
                      <Paper
                        key={`column1 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                          }}
                        >
                          {i + 1}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Second Column */}
                  <Grid item xs={1.5} md={1.5}>
                    {productData?.map((item, i) => (
                      <Paper
                        key={`column2 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        {item?.product_images[0]?.product_image?
                        <img
                          width={"51px"}
                          height={"51px"}
                          style={{ borderRadius: "10px" }}
                          src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${item?.product_images[0]?.product_image}`}
                          alt="pic"
                        />:""}
                      </Paper>
                    ))}
                  </Grid>
                  {/* Third Column */}
                  <Grid item xs={1.5} md={1.5}>
                    {productData?.map((item, i) => (
                      <Paper
                        key={`column3 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            color: "#252525",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.product_id}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Fourth Column */}
                  <Grid item xs={2} md={2}>
                    {productData?.map((item, i) => (
                      <Paper
                        key={`column4 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          noWrap
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.product_name}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* fifth Column */}
                  <Grid item xs={1.5} md={1.5}>
                    {productData?.map((item, i) => (
                      <Paper
                        key={`column5 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",

                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.actual_price}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Sixth Column */}
                  <Grid item xs={1.5} md={1.5}>
                    {productData?.map((item, i) => (
                      <Paper
                        key={`column6 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.discount_price}
                        </Typography>
                      </Paper>
                    ))}{" "}
                  </Grid>
                  {/* Seventh Column */}
                  <Grid item xs={1.5} md={1.5}>
                    {productData?.map((item, i) => (
                      <Paper
                        key={`column7 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <CustomButton
                          sx={{
                            width: "50%",
                            height: "50%",
                            bgcolor: "#31AEF4",
                            "&:hover": {
                              background: "#31AEF4",
                            },
                          }}
                        >
                          {item?.product_rating?.toFixed(1) || 0}
                        </CustomButton>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Eighth Column */}
                  <Grid item xs={2} md={2}>
                    {productData?.map((e, i) => (
                      <Paper
                        key={`column8 + ${i}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                      >
                        <Box
                          sx={{
                            p: "5px",
                            display: "Flex",
                            width: "100%",
                            justifyContent: "center",
                            gap: 1,
                          }}
                        >
                          <Box
                            sx={{
                              cursor: "pointer",
                              width: { xs: "50%", md: "20%" },
                              height: { xs: "50%", md: "20%" },
                            }}
                          >
                            <Link to={`/productdetails/${e.id}`}>
                              <img
                                width={"100%"}
                                height={"100%"}
                                src={eyebox}
                                alt=""
                              />
                            </Link>
                          </Box>
                          <Box
                            sx={{
                              cursor: "pointer",
                              width: { xs: "50%", md: "20%" },
                              height: { xs: "50%", md: "20%" },
                            }}
                          >
                            <img
                              width={"100%"}
                              height={"100%"}
                              src={deletebox}
                              alt=""
                              onClick={() => handleModal(e.id)}
                            />
                          </Box>
                          <Box
                            sx={{
                              cursor: "pointer",
                              width: { xs: "50%", md: "20%" },
                              height: { xs: "50%", md: "20%" },
                            }}
                          >
                            <Link to={`/editproduct/${e.id}`}>
                              <img
                                width={"100%"}
                                height={"100%"}
                                src={editbox}
                                alt=""
                              />
                            </Link>
                          </Box>
                        </Box>
                      </Paper>
                    ))}
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
    </>
  );
};

export default ProductTable;
